const getRoxanneVisitId = () => {
    if (typeof window.DIDataLayer?.user?.get === "function") {
        return parseInt(window.DIDataLayer.user.get().visit_id, 10) || undefined;
    }

    return undefined;
};

export default getRoxanneVisitId;
